import $ from 'jquery';
import Exit from './Exit';

export default function NotiCopied() {
	return (
		<>
			<div id="notify-copied" className="block-touch" style={{ display: "flex" }}>
				<div style={{ display: "inline-block", margin: "auto", border: "5px solid wheat", width: "30em", maxWidth: "100%", }}>
					<div style={{ padding: ".5em 1em", width: "100%", background: "black", color: "white", }}>
						The following is copied!
					</div>
					<textarea id="textarea-copied" style={{ padding: ".5em 1em", width: "100%", height: "20em", background: "white", color: "black", }}></textarea>
				</div>
			</div>
			<Exit id="notify-copied-exit" className="block-touch-exit" style={{zIndex: 31000, position: "fixed"}} onClick={() => $("#notify-copied, #notify-copied-exit").hide()}/>
		</>
	);
}
